module.exports = require("./lrc.js");